/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodicityBaseContract} from '../../../api/contracts/periodicity-base.contract';
import {PeriodicityBaseModel} from './periodicity-base.model';

export class PeriodicityBaseMapper {
    static fromPeriodicityBaseContract(input: PeriodicityBaseContract): PeriodicityBaseModel {
        let model: PeriodicityBaseModel;

        if (input != null) {
            model = {
                code: input.code,
                name: input.name,
                numberOfMonths: input.numberOfMonths,
                active: input.active
            };
        }
        return model;
    }
}
